export const FETCH_LABELS_SUCCESS = "FETCH_LABELS_SUCCESS";

export interface LabelsPayload {
  [group: string]: { [k: string]: string }; // entry.singular, …
}

interface FetchLabelsSuccess {
  type: typeof FETCH_LABELS_SUCCESS;
  payload: LabelsPayload;
}

export type LabelsActionTypes = FetchLabelsSuccess;
